import { Controller } from "stimulus";
import "select2";
import configureSelect2 from "../configureSelect2";

const attribute_str = "data-nested-form-temp-id";
const selector_str = "[" + attribute_str + "]";
export default class extends Controller {
  static values = { element: String };

  append() {
    const template = document.getElementById(this.elementValue);
    const parent = template.parentElement;
    const newId = new Date().getTime();
    let newRecord = template.content.cloneNode(true);

    // Create parent temp id array
    let parent_ids = this.getParentIds(parent);
    parent_ids.push(newId);

    // We use the __new_object__ string as a placeholder for IDs and names in
    // the template. This sets those names and IDs to the current timestamp so
    // that we can submit more than one record per request.
    newRecord.firstElementChild.setAttribute(attribute_str, newId);
    newRecord
      .querySelectorAll("input, select, textarea, label, template, button, a")
      .forEach((el) => {
        for (let attribute of ["name", "id", "for", "data-nested-form-deep-append-element-value"]) {
          if (el.getAttribute(attribute)) {
            el.setAttribute(
              attribute,
              this.replaceNewIds(el.getAttribute(attribute), "__new_object__", parent_ids)
            );
          }
        }
      });

    parent.append(newRecord);

    configureSelect2(parent);

    const event = new CustomEvent("cortana:record_added", {
      bubbles: true,
    });
    parent.dispatchEvent(event);
  }

  getParentIds(element) {
    let parents = this.getNestedParents(element) || [];

    let parent_ids = [];

    for (let parent of parents) {
      parent_ids[this.getNestedParentCount(parent)] = parent.dataset["nestedFormTempId"];
    }

    return parent_ids;
  }

  // We might have lots of elements that have this `d
  getNestedParents(element) {
    let nested_parents = document.querySelectorAll(selector_str) || [];

    let parents = [];
    for (let parent of nested_parents) {
      // Note each element contians itself
      if (parent != element && parent.contains(element)) {
        parents.push(parent);
      }
    }

    return parents;
  }

  getNestedParentCount(element) {
    let nested_parents = document.querySelectorAll(selector_str) || [];

    let count = 0;
    for (let parent of nested_parents) {
      // Note each element contians itself
      if (parent != element && parent.contains(element)) {
        count++;
      }
    }

    return count;
  }

  replaceNewIds(current, token, replacements) {
    let parts = current.split(token);

    let result = "";
    for (var i = 0; i < parts.length; i++) {
      result += parts[i] + (replacements[i] || "");
    }

    return result;
  }
}
